module.exports = __webpack_public_path__ + "img/hill.68a97546.png";